export const TOKEN_KEY = '@token';
export const USER_KEY = 'user';
export const ACTIVEDSTORE = 'acitvedStore';
export const TOKEN_EXPIRATION = '@token_expiration';

export const isAuthenticated = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiration = localStorage.getItem(TOKEN_EXPIRATION);

  if (!token || !expiration) return false;

  const now = Date.now();
  const expirationTime = Number(expiration);

  if (now > expirationTime) {
    logout();
    return false;
  }

  return true;
};

export const getToken = () => {
  if (!isAuthenticated()) return null;
  return localStorage.getItem(TOKEN_KEY);
};

// Função para remover token e limpar dados
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(ACTIVEDSTORE);
  localStorage.removeItem(TOKEN_EXPIRATION);
};
